import BrowserNotSupportedIndex from './browser-not-supported-index';

export default class BrowserNotSupportedIndexDesktop extends BrowserNotSupportedIndex {
    constructor(...args) {
        super(...args);
    }

    /**
     * init() {}
     * bind() {}
     * unbind() {}
     * resize(width, height) {}
     * _destroy() {}
     */
}



// WEBPACK FOOTER //
// ./src/js/pages/browser-not-supported/browser-not-supported-index.desktop.js